var _defs, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2098c4;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m789.74,742.04c0,10.06-1.46,19.87-4.37,29.46-10.31,33.02-31.74,57.79-64.26,74.28-31.33,15.89-67.68,21.51-102.18,19.96-32.54-1.46-64.38-10.24-94.26-23.56-5.68-2.64-11.23-5.55-16.67-8.66-31.46-19.05-55.59-44.04-72.44-74.99-16.88-30.96-25.31-63.12-25.31-96.46,0-3.02.11-5.97.28-8.85,2.67-34.65,13.75-66.54,33.3-95.57,19.51-29.04,44.82-51.57,75.85-67.6,30.1-14.64,60.39-22,90.88-22,7.82,0,15.53.5,23.14,1.46,38.49,4.55,74.96,17.59,109.47,39.13v24.56h-10.88c-3.41-15.03-10.77-26.27-22-33.69-22.5-14.68-49.55-22-81.14-22-40.98,0-78.51,13.9-112.6,41.69-42.12,37.75-64.19,84.98-66.29,141.74,0,32.2,6.75,62.27,20.29,90.17,13.51,27.9,33.02,51.11,58.57,69.56,30.28,20.79,64.01,31.17,101.15,31.17,26.16,0,54.13-6.99,75.67-22.04,16.14-11.27,27.37-25.59,33.62-42.94,3.38-9.38,5.08-18.8,5.08-28.19,0-27.79-11.34-51-34.01-69.59-13.68-10.02-28.5-18.16-44.43-24.45-52.07-21.08-83.45-54.63-94.22-100.59-1.03-6.15-1.53-12.26-1.64-18.41,15.53.57,31.03,1.39,46.56,2.31,4.37,17.7,14.5,33.02,30.46,45.89,11.87,8.96,25.02,16.6,39.38,22.85,8.28,4.19,16.24,8.39,23.88,12.55,23.35,12.55,42.86,28.72,58.57,48.59,13.68,19.83,20.51,41.26,20.51,64.23Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 608.68,
    cy: 389.26,
    r: 55.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c87a432b6ffc59a76cc4821085924966.svg";
export { ForwardRef as ReactComponent };